import { AmountErrorComponent } from './components/amount-error/amount-error.component';
import {
  AddLiabilityScanDesktopComponent,
} from './containers/add-liability-scan-desktop/add-liability-scan-desktop.component';
import {
  AddLiabilityScanMobileComponent,
} from './containers/add-liability-scan-mobile/add-liability-scan-mobile.component';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxFileDropModule } from 'ngx-file-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PayModule } from '../pay/pay.module';
import { SharedModule } from '../shared/shared.module';
import { AmountComponent } from './components/amount/amount.component';
import {
  CancelBillerVerificationDialogComponent,
} from './components/cancel-biller-verification-dialog/cancel-biller-verification-dialog.component';
import {
  DeleteSingleAutomaticPaymentConfirmationDialogComponent,
} from './components/delete-single-automatic-payment-confirmation-dialog/delete-single-automatic-payment-confirmation-dialog.component';
import { EditLiabilityDialogComponent } from './components/edit-liability-dialog/edit-liability-dialog.component';
import {
  ExpandableMenuVerticalComponent,
} from './components/expandable-menu-vertical/expandable-menu-vertical.component';
import {
  FileSuccessfullyUploadedDialogComponent,
} from './components/file-successfully-uploaded-dialog/file-successfully-uploaded-dialog.component';
import { FillAmountDialogComponent } from './components/fill-amount-dialog/fill-amount-dialog.component';
import { FillDescriptionDialogComponent } from './components/fill-description-dialog/fill-description-dialog.component';
import {
  HideLiabilityConfirmationDialogComponent,
} from './components/hide-liability-confirmation-dialog/hide-liability-confirmation-dialog.component';
import {
  LiabilitiesWithUnknownStatusDialogComponent,
} from './components/liabilities-with-unknown-status-dialog/liabilities-with-unknown-status-dialog.component';
import {
  LiabilityExpandableMenuComponent,
} from './components/liability-expandable-menu/liability-expandable-menu.component';
import {
  LiabilityListItemDesktopComponent,
} from './components/liability-list-item-desktop/liability-list-item-desktop.component';
import {
  LiabilityListItemMobileComponent,
} from './components/liability-list-item-mobile/liability-list-item-mobile.component';
import { LiabilityListItemComponent } from './components/list-item/liability-list-item.component';
import {
  SingleAutomaticPaymentCreatedDialogComponent,
} from './components/single-automatic-payment-created-dialog/single-automatic-payment-created-dialog.component';
import { XsellOfferComponent } from './components/xsell-offer/xsell-offer.component';
import { LiabilityDelagateComponent } from './containers/liability-delagate/liability-delagate.component';
import { LiabilityDetailsComponent } from './containers/liability-details/liability-details.component';
import { LiabilityHeaderComponent } from './containers/liability-header/liability-header.component';
import { LiabilityListComponent } from './containers/liability-list/liability-list.component';
import {
  OtherPaymentInfoDialogEntryComponent,
} from './containers/other-payment-info-dialog-entry/other-payment-info-dialog-entry.component';
import { UrgentLiabilitiesComponent } from './containers/urgent-liabilities/urgent-liabilities.component';
import { LiabilitiesRoutingModule } from './liabilities-routing.module';
import { AddLiabilityComponent } from './containers/add-liability/add-liability.component';
import { AddLiabilityCardComponent } from './components/add-liability-card/add-liability-card.component';
import { AddLiabilityManualComponent } from './components/add-liability-manual/add-liability-manual.component';
import { AddLiabilityScanComponent } from './containers/add-liability-scan/add-liability-scan.component';
import { AddedFileRowComponent } from './components/added-file-row/added-file-row.component';
import { DocumentIconSliderComponent } from './components/document-icon-slider/document-icon-slider.component';
import { FileReadingComponent } from './containers/file-reading/file-reading.component';
import {
  LiabilityScanCompletedComponent,
} from './containers/liability-scan-completed/liability-scan-completed.component';
import {
  LiabilityDataConfirmationComponent,
} from './containers/liability-data-confirmation/liability-data-confirmation.component';
import { AddBillerDialogComponent } from './components/add-biller-dialog/add-biller-dialog.component';
import {
  AddLiabilityManualContainerComponent,
} from './containers/add-liability-manual-container/add-liability-manual-container.component';
import {
  LiabilityDataScanConfirmationComponent,
} from './components/liability-data-scan-confirmation/liability-data-scan-confirmation.component';
import { AddLiabilityEmailComponent } from './containers/add-liability-email/add-liability-email.component';
import { MatTableModule } from '@angular/material/table';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TagListComponent } from '../shared/components/tag-list/tag-list.component';
import { EmptyStateComponent } from '../shared/components/empty-state/empty-state.component';
import { SecondaryToolbarComponent } from '../shared/components/secondary-toolbar/secondary-toolbar.component';
import { TagListFilterComponent } from '../shared/components/tag-list-filter/tag-list-filter.component';
import { IconComponent } from '../shared/components/icon/icon.component';
import { ContainerComponent } from '../shared/components/container/container.component';
import { NewTileButtonComponent } from '../shared/components/new-tile-button/new-tile-button.component';

@NgModule({
  declarations: [
    LiabilityDetailsComponent,
    AmountComponent,
    FillAmountDialogComponent,
    FillDescriptionDialogComponent,
    UrgentLiabilitiesComponent,
    LiabilityHeaderComponent,
    LiabilityListComponent,
    LiabilityListItemComponent,
    LiabilityListItemDesktopComponent,
    LiabilityListItemMobileComponent,
    HideLiabilityConfirmationDialogComponent,
    CancelBillerVerificationDialogComponent,
    LiabilitiesWithUnknownStatusDialogComponent,
    OtherPaymentInfoDialogEntryComponent,
    FileSuccessfullyUploadedDialogComponent,
    XsellOfferComponent,
    SingleAutomaticPaymentCreatedDialogComponent,
    DeleteSingleAutomaticPaymentConfirmationDialogComponent,
    LiabilityDelagateComponent,
    EditLiabilityDialogComponent,
    AddLiabilityComponent,
    AddLiabilityCardComponent,
    AddLiabilityManualComponent,
    AddLiabilityEmailComponent,
    LiabilityDataScanConfirmationComponent,
    AddLiabilityManualContainerComponent,
    AddLiabilityScanComponent,
    AddedFileRowComponent,
    AddLiabilityScanMobileComponent,
    AddLiabilityScanDesktopComponent,
    DocumentIconSliderComponent,
    FileReadingComponent,
    LiabilityScanCompletedComponent,
    LiabilityDataConfirmationComponent,
    AmountErrorComponent,
    AddBillerDialogComponent,
  ],

  imports: [
    NgxMaskDirective, NgxMaskPipe,

    CommonModule,
    LiabilitiesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InfiniteScrollModule,
    ClipboardModule,
    NgxFileDropModule,
    PayModule,
    MatTableModule,
    NgxExtendedPdfViewerModule,
    NgOptimizedImage,
    TagListComponent,
    EmptyStateComponent,
    SecondaryToolbarComponent,
    TagListFilterComponent,
    IconComponent, ContainerComponent, LiabilityExpandableMenuComponent, ExpandableMenuVerticalComponent, NewTileButtonComponent,
  ],
  providers: [
    provideNgxMask(),
  ],
  exports: [
    LiabilityExpandableMenuComponent,
  ],
})
export class LiabilitiesModule {
}
